(() => {
  if (window.kukurMobileCommerceBound) return;
  window.kukurMobileCommerceBound = true;
  // Keep the small Inbox activator out of controls and the whole cart summary.
  // Desktop positioning and the open chat panel retain the app's own behavior.
  const positionChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    if (innerWidth > 749) { chat.style.removeProperty('--k-chat-left');chat.style.removeProperty('--k-chat-bottom');chat.removeAttribute('data-mobile-obscured');return; }
    const protectedRects = [...document.querySelectorAll('.product-info h1,.product-price,.k-event-note,.cart-summary,main button:not(.photo-zoom),main select:not(.sr-only),main input:not([type=hidden]),main a')]
      .filter(e => e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden')
      .map(e => e.getBoundingClientRect()).filter(r => r.bottom > 0 && r.top < innerHeight && r.width && r.height);
    const sticky = document.querySelector('[data-mobile-purchase]:not([hidden])');
    const minimum = Math.max(88,(sticky?.getBoundingClientRect().height||0)+20);
    const offsets = [...new Set([minimum,...protectedRects.map(r=>Math.ceil(innerHeight-r.top+12))])].filter(n=>n>=minimum&&n+48<innerHeight).sort((a,b)=>a-b);
    for (const bottom of offsets) for (const left of [16,innerWidth-64]) {
      const top = innerHeight-bottom-48;
      if (protectedRects.some(r=>left<r.right+4&&left+48>r.left-4&&top<r.bottom+4&&top+48>r.top-4)) continue;
      chat.removeAttribute('data-mobile-obscured');chat.style.setProperty('--k-chat-left',left+'px');chat.style.setProperty('--k-chat-bottom',bottom+'px');return;
    }
    chat.setAttribute('data-mobile-obscured','true');
  };
  let frame;
  const schedule = () => { cancelAnimationFrame(frame);frame=requestAnimationFrame(positionChat); };
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule,{passive:true});
  new ResizeObserver(schedule).observe(document.querySelector('main'));
  customElements.whenDefined('shopify-chat').then(()=>{schedule();setTimeout(schedule,500);setTimeout(schedule,1500);});
  const bind = (scope = document) => {
    for (const bar of scope.querySelectorAll('[data-mobile-purchase]')) {
      if (bar.dataset.bound) continue;
      const section = bar.closest('[data-product-section]');
      const primary = section.querySelector('[data-add-to-cart]');
      const price = section.querySelector('[data-product-price]');
      const form = primary?.form;
      if (!primary || !form) continue;
      bar.dataset.bound = 'true';
      const button = bar.querySelector('[data-mobile-add]');
      const sync = () => {
        button.textContent = primary.textContent.trim();
        bar.querySelector('[data-mobile-price]').textContent = price.textContent.trim();
      };
      const observer = new MutationObserver(sync);
      observer.observe(primary, {subtree:true, childList:true, attributes:true});
      observer.observe(price, {subtree:true, childList:true, characterData:true});
      let purchaseFrame;
      const updateVisibility = () => {
        const header = document.querySelector('.site-header');
        const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
        bar.hidden = innerWidth > 749 || primary.getBoundingClientRect().bottom > headerBottom;
        document.body.classList.toggle('k-mbar-on', !bar.hidden);
        schedule();
      };
      const queueVisibility = () => { cancelAnimationFrame(purchaseFrame); purchaseFrame = requestAnimationFrame(updateVisibility); };
      addEventListener('scroll', queueVisibility, {passive:true});
      addEventListener('resize', queueVisibility, {passive:true});
      updateVisibility();
      button.addEventListener('click', () => {
        if (primary.disabled) {
          const missing = [...section.querySelectorAll('[data-option-index]')].find(s => !s.value);
          const target = missing?.getAttribute('aria-hidden') === 'true' ? missing.closest('.field').querySelector('[data-color-value]') : missing;
          const focus = target || primary;
          focus.scrollIntoView({behavior:'smooth',block:'center'});
          focus.focus({preventScroll:true});
          return;
        }
        form.requestSubmit(primary);
      });
      sync();
      const cleanup = event => {
        if (!event.target.contains(bar)) return;
        observer.disconnect();cancelAnimationFrame(purchaseFrame);removeEventListener('scroll',queueVisibility);removeEventListener('resize',queueVisibility);
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
    }
  };
  bind();
  document.addEventListener('shopify:section:load',event=>bind(event.target));
})();
